/* tslint:disable */
/* eslint-disable */
import { AddressDisplayModel as AceXFoundPortalCoreCaqModelsAddressDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/address-display-model';
import { ContactInformationDisplayModel as AceXFoundPortalCoreCaqModelsContactInformationDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/contact-information-display-model';
import { GlobalEnumsAceIdentischmit as AceXFoundPortalCoreEntitiesGlobalEnumsAceIdentischmit } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-identischmit';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AddressDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup } from '@/api/model-index';
import { ContactInformationDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsContactInformationDisplayModelFormGroup } from '@/api/model-index';

export interface IKontaktDisplayModel {
  abweichendeAdresse?: boolean;
  address?: AceXFoundPortalCoreCaqModelsAddressDisplayModel;
  anredeId?: null | string;
  bic?: null | string;
  contactInformation?: AceXFoundPortalCoreCaqModelsContactInformationDisplayModel;
  firstname?: null | string;
  iban?: null | string;
  id?: null | string;
  identischmit?: AceXFoundPortalCoreEntitiesGlobalEnumsAceIdentischmit;
  kontoinhaber?: null | string;
  lastname?: null | string;
  nameDesKreditInstituts?: null | string;
  postfixTitelId?: null | string;
  praefixTitelId?: null | string;
}
export class KontaktDisplayModel extends BaseModel implements IKontaktDisplayModel {
  abweichendeAdresse?: boolean;
  address?: AceXFoundPortalCoreCaqModelsAddressDisplayModel;
  anredeId?: null | string;
  bic?: null | string;
  contactInformation?: AceXFoundPortalCoreCaqModelsContactInformationDisplayModel;
  firstname?: null | string;
  iban?: null | string;
  id?: null | string;
  identischmit?: AceXFoundPortalCoreEntitiesGlobalEnumsAceIdentischmit;
  kontoinhaber?: null | string;
  lastname?: null | string;
  nameDesKreditInstituts?: null | string;
  postfixTitelId?: null | string;
  praefixTitelId?: null | string;
}
class BaseKontaktDisplayModelFormGroup extends FormGroup {
  private static _instance: KontaktDisplayModelFormGroup;
  
  public static get Instance(): KontaktDisplayModelFormGroup {
    this._instance = new KontaktDisplayModelFormGroup({
      abweichendeAdresse: new FormControl(null),
      address: AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup.Instance,
      anredeId: new FormControl(null),
      bic: new FormControl(null),
      contactInformation: AceXFoundPortalCoreCaqModelsContactInformationDisplayModelFormGroup.Instance,
      firstname: new FormControl(null),
      iban: new FormControl(null),
      id: new FormControl(null),
      identischmit: new FormControl(null),
      kontoinhaber: new FormControl(null),
      lastname: new FormControl(null),
      nameDesKreditInstituts: new FormControl(null),
      postfixTitelId: new FormControl(null),
      praefixTitelId: new FormControl(null),
    });

    return this._instance;
  }
}


export class KontaktDisplayModelFormGroup extends BaseKontaktDisplayModelFormGroup {
  public get AbweichendeAdresse(): FormControl {
    return this.controls["abweichendeAdresse"] as FormControl;
  }
  public get Address(): AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup {
    return this.controls["address"] as AceXFoundPortalCoreCaqModelsAddressDisplayModelFormGroup;
  }
  public get AnredeId(): FormControl {
    return this.controls["anredeId"] as FormControl;
  }
  public get Bic(): FormControl {
    return this.controls["bic"] as FormControl;
  }
  public get ContactInformation(): AceXFoundPortalCoreCaqModelsContactInformationDisplayModelFormGroup {
    return this.controls["contactInformation"] as AceXFoundPortalCoreCaqModelsContactInformationDisplayModelFormGroup;
  }
  public get Firstname(): FormControl {
    return this.controls["firstname"] as FormControl;
  }
  public get Iban(): FormControl {
    return this.controls["iban"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Identischmit(): FormControl {
    return this.controls["identischmit"] as FormControl;
  }
  public get Kontoinhaber(): FormControl {
    return this.controls["kontoinhaber"] as FormControl;
  }
  public get Lastname(): FormControl {
    return this.controls["lastname"] as FormControl;
  }
  public get NameDesKreditInstituts(): FormControl {
    return this.controls["nameDesKreditInstituts"] as FormControl;
  }
  public get PostfixTitelId(): FormControl {
    return this.controls["postfixTitelId"] as FormControl;
  }
  public get PraefixTitelId(): FormControl {
    return this.controls["praefixTitelId"] as FormControl;
  }
  

}

export module KontaktDisplayModelForm
  {
    export class FormFields
    {
      static _abweichendeAdresse: string = "abweichendeAdresse";
      static _address: string = "address";
      static _anredeId: string = "anredeId";
      static _bic: string = "bic";
      static _contactInformation: string = "contactInformation";
      static _firstname: string = "firstname";
      static _iban: string = "iban";
      static _id: string = "id";
      static _identischmit: string = "identischmit";
      static _kontoinhaber: string = "kontoinhaber";
      static _lastname: string = "lastname";
      static _nameDesKreditInstituts: string = "nameDesKreditInstituts";
      static _postfixTitelId: string = "postfixTitelId";
      static _praefixTitelId: string = "praefixTitelId";
    }
  }

